jQuery(function($){

	blockSlider();
	rwdMenu();
    inifFancybox();
	goTo();
    activities();
    downloadsCounter();
    faq();
    setPhotoMinHeight();
    showCareer();

    function showCareer() {
        $('.show-career').click(function(event) {
            event.preventDefault();
            $(this).toggleClass('active');
            $(this).parent('article').children('.desc').slideToggle(500);
        });
    }
    

	jQuery(function ($) {

	function updateArticlesState() {

		const scrollTop = $(window).scrollTop();
		const triggerPoint = scrollTop + 300;

		let activeArticle = null;

		$('.about-us__wrapper article').each(function () {

			const $article = $(this);

			const articleTop = $article.offset().top;
			const articleBottom = articleTop + $article.outerHeight();

			// ACTIVE
			if (triggerPoint >= articleTop && triggerPoint < articleBottom) {
				activeArticle = $article;
			}

			// VIEWED
			if (triggerPoint >= articleTop) {
				$article.addClass('viewed');
			} else {
				$article.removeClass('viewed');
			}
		});

		// fallback dla pierwszego
		if (!activeArticle) {
			activeArticle = $('.about-us__wrapper article').first();
		}

		$('.about-us__wrapper article').removeClass('active');

		activeArticle.addClass('active');
	}

	$(window).on('scroll resize load', function () {
		updateArticlesState();
	});

	updateArticlesState();

});

    // przy resize (ważne!)
    $(window).on('resize', function () {
        setPhotoMinHeight();
    });

    function setPhotoMinHeight() {
        var windowWidth = $(document).width();
        console.log(windowWidth);
        if (windowWidth > 1000) {
            $('.text-photo').each(function () {
                var $section = $(this);

                var descHeight = $section.find('.text-photo__description').outerHeight();
                var $img = $section.find('.text-photo__photo img');

                $img.css('min-height', descHeight + 'px');
            });

            $('.palette__wrapper').each(function () {
                var $section = $(this);

                var descHeight = $section.find('.palette__wrapper .description').outerHeight();
                var $img = $section.find('.palette__wrapper .photo img');
                console.log(descHeight);
                $img.css('min-height', descHeight + 'px');
            });
        }
    }
    
    function downloadsCounter() {
        $(document).on('click', '.js-download-file', function () {
            var $link = $(this);
            var attachmentId = $link.data('attachment-id');

            if (!attachmentId || typeof prodDownloads === 'undefined' || !prodDownloads.ajaxurl) {
                return;
            }

            $.ajax({
                url: prodDownloads.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'increment_download_count',
                    attachment_id: attachmentId
                },
                success: function (response) {
                    if (response.success && response.data && typeof response.data.count !== 'undefined') {
                        $link.closest('article').find('.js-download-count').text(response.data.count);
                    }
                }
            });
        });
    }

    function faq() {

        $('.faq__question').click(function(event) {

            event.preventDefault();

            var href = $(this).attr('href');
            var $target = $('.faq__answer' + href);

            if ($(this).hasClass('active')) {

                $(this).removeClass('active');

                $target.slideUp(300);

                return;

            } else {

                $('.faq__answer').slideUp(300);
                $('.faq__question').removeClass('active');

                $(this).addClass('active');

                $target.slideDown(300, function () {

                    $('html, body').animate({
                        scrollTop: $(href).offset().top - 120
                    }, 400);

                });
            }
        });
    }

    function activities() {
        $('.activities__nav a').click(function(event) {
            event.preventDefault();
            var href = $(this).attr('href');
            
            $('.activities__nav a').removeClass('active');
            $(this).addClass('active');

            $('.activities__content article').removeClass('active');
            $(href).addClass('active');
        });
    }
	function goTo() {

    $(".go-to").click(function(event) {
        event.preventDefault();
        var href = $(this).attr('href');
        var pos = -100;
        jQuery('html, body').animate({
            scrollTop: jQuery(href).offset().top + pos
        }, 500);
        });
    }

    function inifFancybox() {
        Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        loop : true,

        afterClose: function(instance, current) {
            var videos = document.querySelectorAll('.inline-movies');

            videos.forEach(function(video) {
                video.pause();
            });
        }
        });
    }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1140) {

			$('.site-header__navigation .menu-item-has-children > a').on('click', function(event) {
				event.stopPropagation();
				$(this).parent('li').children('ul').slideToggle(300);
				$(this).parent('li').toggleClass('active');
                
			});
			
			// Dodanie obsługi kliknięcia na rodzicu, aby zatrzymać propagację tylko na linkach
			$('.site-header__navigation .menu-item-has-children').on('click', function(event) {
				if (!$(event.target).is('a')) {
					event.stopPropagation();
					$(this).children('ul').slideToggle(300);
					$(this).toggleClass('active');
                    
				}
			});

           
		}
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {

			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;

			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	    });
	}());

    $(window).scroll(function() {   
        var windowWidth = $(window).width();
        var scroll = $(window).scrollTop();

        if (scroll >= 250 ) {
            $("header").addClass("scrolled");
        
        } else {
            $("header").removeClass("scrolled");
        }

    });

	function blockSlider() {

		jQuery('.home-slider').owlCarousel({
            animateOut: 'fadeOut',
	        animateIn: 'fadeIn',
			loop:true,
			margin:0,
			nav:false,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
			singleItem: true,
			navText: ['',''],
			autoplayHoverPause:true
		});

        jQuery('.footer-logos-slider').owlCarousel({
            loop:true,
            margin:32,
            nav:true,
            items:1,
            autoplay:true,
            autoplayTimeout:4000,
            autoplaySpeed: 1700,
            slideSpeed: 1700,
            navSpeed: 1700,
            dotsSpeed: 1700,
            dots: false,
            singleItem: true,
            stagePadding: 0,
            navText: ['',''],
            autoplayHoverPause:true,
            responsive:{
                0:{
                items:1,
                },
                960:{
                items:2,
                margin:32,
                },
                1100:{
                items:3,
                margin:32,
                },
                1240:{
                items:4,
                margin:70,
                },
                1440:{
                    items:5,
                    margin:110,
                },
                
            }
        });
    }

})